<script lang="ts" setup>
import TheOpcTemplate from '@/components/opc/templates/TheOpcTemplate.vue'
import { translate } from '@/plugins/i18n'
import {
  containsPrivateInfo,
  NO_INDEX_FOLLOW
} from '@/services/helpers/MetaHelper.js'
import { useCartStore } from '@/stores/cart'
import { useNewCheckoutStore } from '@/stores/newCheckout'
import { useOpcStore } from '@/stores/opc'
import { useHead } from '@unhead/vue'
import { storeToRefs } from 'pinia'
import { computed, defineAsyncComponent, onBeforeMount, onUnmounted } from 'vue'

// Async component
const AlertBanner = defineAsyncComponent(
  () => import('@/components/basic/atoms/AlertBanner.vue')
)

const checkoutStore = useNewCheckoutStore()
const cartStore = useCartStore()
const opcStore = useOpcStore()
const { product, updating } = storeToRefs(opcStore)

// Computed properties
const productIsVisible = computed(
  () => updating.value || product.value.is_enabled
)
const title = computed(() => {
  const manufacturer = product.value.manufacturer_name ?? ''
  const productName = product.value.name ?? ''
  return `${manufacturer} ${productName}`.trim()
})
const description = computed(() => {
  return product.value.name
    ? product.value.description
    : translate('fallback_meta_description')
})

useHead({
  title,
  meta: [
    {
      name: 'robots',
      content: computed(() =>
        containsPrivateInfo() ? NO_INDEX_FOLLOW : product.value.robots
      )
    },
    { name: 'description', content: description }
  ]
})

onBeforeMount(() => {
  opcStore.refreshProduct()
  cartStore.removeCreditsFromCart()
})

onUnmounted(() => {
  checkoutStore.abortCheckout()
})
</script>

<template>
  <div id="content" data-elbglobals="page_type:opc">
    <AlertBanner
      v-if="!productIsVisible"
      :text="translate('alert_message_preview_mode')"
    />
    <TheOpcTemplate id="page-template" />
  </div>
</template>
